import { render, staticRenderFns } from "./ParameterEdit.vue?vue&type=template&id=4c46a797&scoped=true&"
import script from "./ParameterEdit.vue?vue&type=script&lang=js&"
export * from "./ParameterEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c46a797",
  null
  
)

export default component.exports